export const DEFAULT_PASSWD_DURATION_DAYS = 90;
const MILLIS_PER_DAY = 24 * 60 * 60 * 1000;

export const normalizePasswdDurationDays = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : DEFAULT_PASSWD_DURATION_DAYS;
};

export const passwordExpiryClass = (lastPasswdUpdate, passwdDurationDays, now = new Date()) => {
    if (!lastPasswdUpdate) {
        return '';
    }

    const lastUpdateDate = new Date(lastPasswdUpdate);
    if (Number.isNaN(lastUpdateDate.getTime())) {
        return '';
    }

    const ttlDays = normalizePasswdDurationDays(passwdDurationDays);
    const expiryMs = lastUpdateDate.getTime() + (ttlDays * MILLIS_PER_DAY);
    const remainingMs = expiryMs - now.getTime();

    const twoWeeksMs = 14 * MILLIS_PER_DAY;
    const oneMonthMs = 30 * MILLIS_PER_DAY;

    if (remainingMs <= twoWeeksMs) {
        return 'passwd-expiry-red';
    }
    if (remainingMs <= oneMonthMs) {
        return 'passwd-expiry-yellow';
    }
    return 'passwd-expiry-green';
};
